<div class="title request-details-title">
  <div class="container container-max-width">
    <div>
      <h4>PF Request Details</h4>
    </div>
    <div class="action-container">
      <button
        *ngIf="request?.DemandId"
        type="button"
        class="btn btn-primary me-2"
        data-test="ViewDemand"
        (click)="viewDemand()"
      >
        View Demand
      </button>
      <button *ngIf="canApproveOrReject && request" type="button" class="btn btn-success" (click)="approveRequest()">
        Approve
      </button>
      <button *ngIf="canApproveOrReject && request" type="button" class="btn btn-danger ms-2" (click)="rejectRequest()">
        Reject
      </button>
      <button *ngIf="isAdmin && request" type="button" class="btn btn-danger ms-2" (click)="deleteRequest()">
        Delete
      </button>
    </div>
  </div>
</div>

<div class="container container-content container-max-width">
  <div class="landing-main mt-3" *ngIf="request">
    <fieldset class="fieldsetstyle mb-4">
      <h5>Request Information</h5>
      <hr />
      <dl class="row mb-0">
        <dt class="col-sm-3 col-form-label request-label">Request ID:</dt>
        <dd class="col-sm-9 col-form-label">{{ request.Id }}</dd>

        <dt class="col-sm-3 col-form-label request-label">Status:</dt>
        <dd class="col-sm-9 col-form-label">{{ request.Status }}</dd>

        <dt class="col-sm-3 col-form-label request-label">Service Tree ID:</dt>
        <dd class="col-sm-9 col-form-label">{{ request.ServiceTreeId }}</dd>

        <dt class="col-sm-3 col-form-label request-label">Region:</dt>
        <dd class="col-sm-9 col-form-label">{{ request.Region }}</dd>

        <dt class="col-sm-3 col-form-label request-label">Manatree:</dt>
        <dd class="col-sm-9 col-form-label">{{ request.Manatree }}</dd>

        <dt class="col-sm-3 col-form-label request-label">Created By:</dt>
        <dd class="col-sm-9 col-form-label">{{ request.CreatedBy }}</dd>

        <dt class="col-sm-3 col-form-label request-label">
          Approved By:
          <i
            class="fa fa-info-circle"
            [ngbTooltip]="approversTooltip"
            placement="top"
            container="body"
            tabindex="0"
            [attr.aria-label]="approversTooltip"
          ></i>
        </dt>
        <dd class="col-sm-9 col-form-label">{{ request.ApprovedBy || "-" }}</dd>

        <dt class="col-sm-3 col-form-label request-label">Created Date:</dt>
        <dd class="col-sm-9 col-form-label">{{ request.CreatedTime | date: "medium" }}</dd>
      </dl>
    </fieldset>

    <fieldset class="fieldsetstyle">
      <h5>Sub Requests</h5>
      <hr />
      <div class="subrequest-table-shell mb-3">
        <ag-grid-angular
          class="ag-theme-balham"
          style="width: 100%"
          domLayout="autoHeight"
          [columnDefs]="subRequestColumnDefs"
          [defaultColDef]="subRequestDefaultColDef"
          [rowData]="request.SubRequests"
          [overlayNoRowsTemplate]="'No subrequests are associated with this request.'"
          (firstDataRendered)="$event.api.sizeColumnsToFit()"
        >
        </ag-grid-angular>
      </div>
    </fieldset>
  </div>
</div>
